// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import { gql } from "@apollo/client";

export default gql`
  query patientActiveQuery {
    patient: _patient {
      active: patient_active
    }
  }
`;
